import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Select } from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import {
  AOG,
  MAKE_OFFER,
  NO_QUOTE,
  AWAITING_INFO_TO_COMPLETE,
  EXCHANGE_ONLY,
  STANDARD,
  AS_IS,
  QUOTE_TYPE,
  OFFER
} from "MODULES/OutgoingQuotes/constants";
import { properCase } from "LIB/formatters/text";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import { MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION } from "APP_ROOT/constants";

export default function OutgoingQuoteTypeSelect({
  change = () => {},
  condition,
  inventory_id: inventoryId,
  offer,
  price_per_unit,
  quantity,
  exchange_fee,
  price,
  quoteTypes,
  tag_date: tagDate,
  tagged_by: taggedBy,
  trace_type: traceType,
  traced_to: tracedTo,
  warranty
}) {
  const minOutrightVal = useSettings()[
    MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION
  ];

  const handleChange = ev => {
    const newQuoteType = ev.target.value;

    if (offer) {
      offer.input.onChange(null);
    }

    if (
      [EXCHANGE_ONLY, MAKE_OFFER, NO_QUOTE, AWAITING_INFO_TO_COMPLETE].includes(
        newQuoteType
      )
    ) {
      price_per_unit.input.onChange(null);
    } else if ([AOG, STANDARD].includes(newQuoteType)) {
      price_per_unit.input.onChange(price);
    }

    if (newQuoteType === OFFER) {
      change("send_quote", false);
    }

    if (newQuoteType === NO_QUOTE) {
      quantity.input.onChange(0);
      [
        condition,
        inventoryId,
        traceType,
        tagDate,
        taggedBy,
        tracedTo
      ].forEach(f => f.input.onChange(null));
    }

    if (newQuoteType !== EXCHANGE_ONLY) {
      exchange_fee.input.onChange(null);
    }

    if (
      (minOutrightVal && Number(minOutrightVal) > price) ||
      newQuoteType === MAKE_OFFER
    ) {
      exchange_fee.input.onChange(null);
    }

    if (newQuoteType === AS_IS) {
      warranty.input.onChange("No Warranty, unit sold as-is.");
    } else {
      warranty.input.onChange(null);
    }
  };

  return (
    <Field
      name={QUOTE_TYPE}
      component={Select}
      options={toOptions(quoteTypes)}
      label={properCase(QUOTE_TYPE)}
      prompt={null}
      onChange={handleChange}
      required
    />
  );
}

OutgoingQuoteTypeSelect.propTypes = {
  condition: PropTypes.instanceOf(Object).isRequired,
  change: PropTypes.func,
  inventory_id: PropTypes.instanceOf(Object).isRequired,
  price_per_unit: PropTypes.instanceOf(Object).isRequired,
  quantity: PropTypes.instanceOf(Object).isRequired,
  tag_date: PropTypes.instanceOf(Object).isRequired,
  tagged_by: PropTypes.instanceOf(Object).isRequired,
  trace_type: PropTypes.instanceOf(Object).isRequired,
  traced_to: PropTypes.instanceOf(Object).isRequired,
  exchange_fee: PropTypes.instanceOf(Object).isRequired,
  quoteTypes: PropTypes.instanceOf(Object).isRequired,
  warranty: PropTypes.instanceOf(Object).isRequired,
  price: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/OutgoingQuoteTypeSelect.jsx